export default __webpack_public_path__ + "static/media/IconDesc_FusedModularFrame.64.c0937880.png";